module.exports = __webpack_public_path__ + "static/media/spotlight.192546ae.jpeg";